import axios from "axios";

const state = {
  aerzte: [],
};

const getters = {
  getAerzte: (state) => {
    return state.aerzte;
  },
};

const actions = {
  async Search({ commit, rootGetters }, term) {
    if (term.length >= 3) {
      let config = {
        headers: rootGetters['auth/authHeaders'],
        params: {
          search: term,
        },
      };
      const response = await axios.get("aerzte/", config);
      await commit("setAerzte", response.data.results);
    }
  },

  async findArzt({ rootGetters }, arztNum) {
    let config = {
      headers: rootGetters['auth/authHeaders'],
    };

    const response = await axios.get("aerzte/" + arztNum + "/", config);
    return response;
  },

  async createDoctor({ rootGetters }, data) {
    let config = {
      headers: rootGetters['auth/authHeaders'],
    };

    return axios
      .post("aerzte/", data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
};

const mutations = {
  setAerzte(state, data) {
    state.aerzte = data;
  },

  clearAerzte(state) {
    state.aerzte = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
